import React from "react";
import { useNavigate } from "react-router-dom";

import "../Styles/JournalsPage.css";

import {
  BookOpen,
  Wallet,
  ShoppingCart,
  Receipt,
  FileSpreadsheet,
  Scale,
  ArrowLeft,
  ChevronRight,
} from "lucide-react";

const journals = [
  {
    id: "cash",
    name: "Cash Journal",
    description:
      "Monitor bank movements, cash flow and daily balancing.",
    route: "/journals/cash",
    icon: Wallet,
    accent: "teal",
  },

  {
    id: "purchase",
    name: "Purchase Journal",
    description:
      "Track expenses, supplier purchases and inventory acquisition.",
    route: "/journals/purchases",
    icon: ShoppingCart,
    accent: "orange",
  },

  {
    id: "sales",
    name: "Sales Journal",
    description:
      "View all cash and credit sales transactions across operations.",
    route: "/journals/sales",
    icon: Receipt,
    accent: "green",
  },

  {
    id: "general",
    name: "General Journal",
    description:
      "Record adjusting entries, liabilities and miscellaneous postings.",
    route: "/journals/general",
    icon: BookOpen,
    accent: "purple",
  },

  {
    id: "ledger",
    name: "General Ledger",
    description:
      "Consolidated overview of all account movements and balances.",
    route: "/ledger",
    icon: FileSpreadsheet,
    accent: "blue",
  },

  {
    id: "trial",
    name: "Trial Balance",
    description:
      "Generate summarized account balances for reconciliation.",
    route: "/trial-balance",
    icon: Scale,
    accent: "red",
  },
];

const JournalsPage = () => {

  const navigate = useNavigate();

  return (

    <div className="journals-page">

      {/* =====================================
          HERO
      ===================================== */}

      <div className="journals-hero">

        {/* LEFT */}

        <div className="journals-hero-left">

          <div className="hero-pill">
            <BookOpen size={15} />
            <span>Journal Center</span>
          </div>

          <h1>
            Journal
            <br />
            Management
          </h1>

          <p>
            Manage financial journals, ledgers,
            trial balances and operational entries
            from a centralized accounting workspace.
          </p>

          <div className="hero-actions">

            <button
              className="hero-btn primary"
              onClick={() =>
                navigate("/accounts")
              }
            >
              Open Accounts
              <ChevronRight size={17} />
            </button>

            <button
              className="hero-btn secondary"
              onClick={() =>
                navigate("/accounts")
              }
            >
              <ArrowLeft size={16} />
              Back
            </button>

          </div>

        </div>

        {/* RIGHT ORBIT */}

        <div className="journals-orbit">

          {/* CENTER */}

          <div className="journal-orbit-center">
            <BookOpen size={42} />
          </div>

          {/* FLOATING CARDS */}

          <div className="journal-orbit-card journal-orbit-1">
            <span>Cash Flow</span>
          </div>

          <div className="journal-orbit-card journal-orbit-2">
            <span>Ledgers</span>
          </div>

          <div className="journal-orbit-card journal-orbit-3">
            <span>Balancing</span>
          </div>

          <div className="journal-orbit-card journal-orbit-4">
            <span>Reports</span>
          </div>

        </div>

      </div>

      {/* =====================================
          GRID
      ===================================== */}

      <div className="journal-grid">

        {journals.map((journal) => {

          const Icon = journal.icon;

          return (

            <div
              key={journal.id}
              className={`journal-card ${journal.accent}`}
              onClick={() =>
                navigate(journal.route)
              }
            >

              <div className="journal-card-top">

                <div className="journal-icon">
                  <Icon size={24} />
                </div>

                <ChevronRight
                  size={18}
                  className="journal-arrow"
                />

              </div>

              <div className="journal-content">

                <h3>{journal.name}</h3>

                <p>
                  {journal.description}
                </p>

              </div>

              <div className="journal-footer">
                Open Module
              </div>

            </div>

          );

        })}

      </div>

    </div>

  );

};

export default JournalsPage;